import { CLEAR_ACTIVE_LICENSE, FETCH_ACTIVE_LICENSE, SET_ACTIVE_LICENSE } from "../actions";

export const getActiveLicense = (licenseData) => ({
    type: FETCH_ACTIVE_LICENSE,
    payload: { licenseData },
});

export const setActiveLicense = (activeLicenseData) => ({
    type: SET_ACTIVE_LICENSE,
    payload: activeLicenseData,
});

export const clearActiveLicense = () => ({
    type: CLEAR_ACTIVE_LICENSE,
});
